const ADVERTISEMENT_GETTERS = {
  getAdvertisementList: (state) => state.advertisements,
  getAdvertisement: (state) => state.advertisement,
  getLoadingState: (state) => state.status.loading,
  getButtonLoadingState: (state) => state.buttonLoading,
  getBestmatch: (state) => state.advertisementBestmatch,
};

export default ADVERTISEMENT_GETTERS;
